// extracted by mini-css-extract-plugin
export var page_header = "PageHeader-module--page_header--Og48a";
export var page_thumbnail = "PageHeader-module--page_thumbnail--eBMvt";
export var page_title = "PageHeader-module--page_title--6X0WI";